import { render, staticRenderFns } from "./fitness.vue?vue&type=template&id=15bd12fa"
import script from "./fitness.vue?vue&type=script&lang=js"
export * from "./fitness.vue?vue&type=script&lang=js"
import style0 from "./fitness.vue?vue&type=style&index=0&id=15bd12fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports